"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInstantService = void 0;
const history_1 = require("../models/history");
const api_1 = require("./api");
const EINSTANT_BET_PATH = 'einstant/api/v1/bet';
const EINSTANT_PATH = 'einstant/api';
class EInstantService {
    static async getEinstantBetHistory(pageNumber, pageSize) {
        try {
            const response = await api_1.API.get({
                url: `${EINSTANT_BET_PATH}/transaction/consolidated`,
                query: {
                    size: pageSize,
                    page: pageNumber
                }
            });
            if (response) {
                const data = history_1.HistoryEInstantGrouped.JsonToEInstantsGrouped(response.content);
                return {
                    historyEInstants: data,
                    eInstantsLastPage: data.length < pageSize
                };
            }
            return {
                historyEInstants: undefined,
                activitiesLastPage: undefined
            };
        }
        catch (e) {
            throw e;
        }
    }
    static async getEinstantBetHistoryDetails(gameId, pageNumber, pageSize) {
        try {
            const response = await api_1.API.get({
                url: `${EINSTANT_BET_PATH}/transaction/game/${gameId}`,
                query: {
                    size: pageSize,
                    page: pageNumber
                }
            });
            if (response) {
                const data = history_1.HistoryEInstant.JsonToEInstants(response.content);
                return {
                    historyEInstants: data,
                    eInstantsLastPage: data.length < pageSize
                };
            }
            return {
                historyEInstants: undefined,
                activitiesLastPage: undefined
            };
        }
        catch (e) {
            throw e;
        }
    }
    static async getPlayStyles() {
        try {
            return await api_1.API.get({
                url: `${EINSTANT_PATH}/play-styles`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getPjpNames() {
        try {
            return await api_1.API.get({
                url: `${EINSTANT_PATH}/pjp/name`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getGameThemes() {
        try {
            return await api_1.API.get({
                url: `${EINSTANT_PATH}/game-themes`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getGames(params) {
        try {
            let query = '';
            if (!!params) {
                const { filters, page, size } = params;
                if (filters) {
                    query = filters;
                }
                if (page) {
                    query += query.trim().length > 0 ? `&page=${page}` : `page=${page}`;
                }
                if (size) {
                    query += query.trim().length > 0 ? `&size=${size}` : `size=${size}`;
                }
            }
            if (query.length > 0) {
                query = `?${query}`;
            }
            return await api_1.API.get({
                url: `${EINSTANT_PATH}/games${query}`
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.EInstantService = EInstantService;
//# sourceMappingURL=einstant-service.js.map